import uuid from 'react-uuid';

const createCastEntries = (count, fields) =>
  Array.from({ length: count }, () => ({
    ...Object.fromEntries(fields.map((field) => [field, null])),
  }));

export default {
  title: '',
  aspect_ratio: null,
  rating_mpaa: {
    intended: null,
    actual: null,
  },
  genres: [],
  domestic_country: null,
  domestic_release_date: null,
  release_dates: [{ country: '', date: '' }],
  summary: null,
  keywords: [],
  non_english_dialogues: null,
  cast: {
    directors: createCastEntries(1, ['name', 'known_for']),
    writers: createCastEntries(1, ['name', 'previous_works']),
    producers: createCastEntries(3, ['name', 'previous_works', 'role']),
    actors: createCastEntries(3, ['name', 'character', 'type']),
    editors: [],
    casting_directors: [],
    cinematographers: [],
    composers: [],
    production_designers: [],
    art_directors: [],
    animators: [],
  },
  awards: [],
  production_countries: [],
  production_year: null,
  locations: [],
  // production: 'production',
  official_pages: [],
  ratings: {
    imdb: '0',
    metascore: '0',
    votes: '0',
  },
  runtime: null,
  financials: {
    production_budget: 0,
    marketing_budget: 0,
    gross: {
      worldwide: 0,
      domestic: 0,
    },
  },
  festivals: null,
  theatrical_exhibition: null,
  based_on: null,
  inspired_by: null,
  current_stage: null,
  development_agmt_url: null,
  production_companies: [],
  special_effects: [],
  additional_companies: [],
  distributors: {
    'North America': [],
    UK: [],
    Europe: [],
    'Far East': [],
    'Latin America': [],
    'Central America': [],
    'Middle East': [],
    'Eastern Europe': [],
  },
  downloadables: {
    film_data: [],
    script: [],
    development_deal: [],
    production_budget: [],
    marketing_budget: [],
    distribution_agreement: [],
  },
  is_private: false,
};
